// Test script for User Profile API
import { userApiService } from '../services/userApi';

export const testUserProfileAPI = async () => {
  console.log('=== Testing User Profile API ===');
  
  try {
    // Test get profile
    console.log('Testing GET /api/users/profile...');
    const profileResult = await userApiService.getProfile();
    console.log('Get Profile Result:', profileResult);
    
    if (profileResult.success) {
      console.log('✅ Get profile successful');
      console.log('User data:', profileResult.data);
    } else {
      console.log('❌ Get profile failed:', profileResult.error);
    }
    
    // Test update profile
    console.log('\nTesting PUT /api/users/profile...');
    const updateData = {
      province: 'Hà Nội',
      city: 'Hoàn Kiếm',
      ward: 'Phường Hàng Trống',
      gender: 'male' as const,
      birthYear: 1990
    };
    
    const updateResult = await userApiService.updateProfile(updateData);
    console.log('Update Profile Result:', updateResult);
    
    if (updateResult.success) {
      console.log('✅ Update profile successful');
      console.log('Updated user data:', updateResult.data);
    } else {
      console.log('❌ Update profile failed:', updateResult.error);
    }
    
  } catch (error) {
    console.error('❌ API Test Error:', error);
  }
  
  console.log('=== Test completed ===');
};

// Add to window for browser console testing
if (typeof window !== 'undefined') {
  (window as any).testUserProfileAPI = testUserProfileAPI;
}
